var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpFeatureIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v110H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.72 96.44c23.594 0 42.72-19.126 42.72-42.72C96.44 30.127 77.315 11 53.72 11 30.127 11 11 30.127 11 53.72c0 23.594 19.127 42.72 42.72 42.72ZM72.17 53.093v1.622",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.216 55.247A30.402 30.402 0 0 1 26.49 39.89M80.397 68.593c.054-.096.112-.19.165-.286M56.335 84.145a30.91 30.91 0 0 1-2.617.119 30.447 30.447 0 0 1-12.03-2.464M81.437 40.89c.146.315.293.63.428.946M69.155 80.074a30.616 30.616 0 0 0 5.284-3.916M81.438 40.89c.473-11.537-4.188-17.17-14.948-18.773-12.556-1.872-35.567 3.018-39.077 11.963a14.032 14.032 0 0 0-.922 5.813M81.375 42.023c.026-.384.046-.762.061-1.133M29.997 50.52c-1.428-2.406-3.313-6.333-3.507-10.63",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.825 32.66c1.436 2.935 1.85 6.836 1.294 11.894M67.152 26.288a26.118 26.118 0 0 0-2.597-.533c-10.732-1.6-30.403 2.581-33.403 10.225-2.358 6.008 1.066 12.326 2.747 14.923",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.825 32.66c-1.587-3.242-4.442-5.294-8.677-6.372M23.218 55.247l-4.254 3.521a6.25 6.25 0 0 0-.631 9.02l11.602 12.747a4.102 4.102 0 0 0 5.655.394l.345-.285M37.515 54.396l-1.164-1.543a6.215 6.215 0 0 0-2.451-1.95M29.996 50.52A6.211 6.211 0 0 0 27.37 51.8l-4.154 3.445",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.995 50.52a6.278 6.278 0 0 1 3.904.383M37.516 54.396l8.76-1.859a6.25 6.25 0 0 1 7.466 5.099l.263 1.6M36.642 54.582l.872-.186M52.452 79.513 41.688 81.8M36.642 54.582l-1.05.223a6.221 6.221 0 0 0-1.985.8M34.816 77.703l.385 1.473a4.09 4.09 0 0 0 .73 1.473M33.609 55.605a6.25 6.25 0 0 0-2.765 6.895l3.973 15.203M35.93 80.649a4.1 4.1 0 0 0 4.094 1.504l1.663-.353M81.375 42.023c.158-.07.324-.127.489-.186M54.006 59.237a7.493 7.493 0 0 0-2.598 1.907M74.435 76.158c-.047.01-.092.024-.14.033a7.48 7.48 0 0 1-3.964-.32 7.536 7.536 0 0 1-.406 1.113M81.376 42.023a7.534 7.534 0 0 0-3.445 3.072 7.611 7.611 0 0 0-.807-.54M80.396 68.592a7.515 7.515 0 0 1-5.96 7.566",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.863 41.837a7.52 7.52 0 0 1 6.052 13.729 7.506 7.506 0 0 1-7.356 12.742M77.12 44.554a7.507 7.507 0 0 0-11.334 6.327 7.508 7.508 0 0 0-10.118 7.84c-.01 0-.02 0-.03.004-.563.11-1.11.282-1.634.515",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.394 68.594c0-.112 0-.224-.009-.336.056.02.117.03.174.05M51.408 61.144a7.555 7.555 0 0 0-1.383 2.292",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.836 72.326a7.467 7.467 0 0 1-2.811-8.89M52.837 72.325a9.07 9.07 0 0 1 2.783-3.279M52.837 72.325a8.948 8.948 0 0 0-.383 7.188",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.618 69.046a9.029 9.029 0 0 1 14.338 7.311c0 .211-.017.417-.031.624M56.335 84.145a9.059 9.059 0 0 1-3.883-4.632",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.152 80.074a9.019 9.019 0 0 1-12.818 4.07M69.927 76.984a8.985 8.985 0 0 1-.772 3.09M57.502 76.473l2.135 1.168 1.168 2.135a.128.128 0 0 0 .225 0l1.167-2.135 2.136-1.168a.129.129 0 0 0 0-.224l-2.136-1.169-1.167-2.135a.128.128 0 0 0-.225 0l-1.168 2.135-2.135 1.169a.128.128 0 0 0-.067.112.13.13 0 0 0 .067.112ZM44.475 46.308a3.744 3.744 0 1 0-1.72-7.288 3.744 3.744 0 0 0 1.72 7.288ZM57.435 60.791v1.444M67.152 63.134v-1.62M80.617 57.769v1.62M75.556 66.068v1.621M82.18 47.148v1.62",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpFeatureIcon2);
export default __webpack_public_path__ + "static/media/mp-feature-icon-2.3a8b029df84a58ce85775f1019b08212.svg";
export { ForwardRef as ReactComponent };